import { useEffect, useState } from "react";
import axios from "axios";
import { Link } from "react-router-dom";
import { ArrowLeft, Inbox, RefreshCw, LogOut } from "lucide-react";
import { useAuth } from "../auth";

const API = `${process.env.REACT_APP_BACKEND_URL}/api`;

export default function Admin() {
  const { user, logout } = useAuth();
  const [quotes, setQuotes] = useState([]);
  const [loading, setLoading] = useState(true);

  const load = async () => {
    setLoading(true);
    try {
      const { data } = await axios.get(`${API}/quotes`, { withCredentials: true });
      setQuotes(data);
    } catch (e) {
      setQuotes([]);
    } finally {
      setLoading(false);
    }
  };

  useEffect(() => {
    load();
  }, []);

  return (
    <div data-testid="admin-page" className="min-h-screen bg-[#050505] px-6 md:px-10 py-12">
      <div className="max-w-[1200px] mx-auto">
        <div className="flex items-center justify-between mb-10">
          <div>
            <Link
              to="/"
              data-testid="admin-back"
              className="inline-flex items-center gap-2 font-mono-accent text-xs uppercase tracking-[0.2em] text-neutral-400 hover:text-cyan transition-colors"
            >
              <ArrowLeft size={14} /> Retour au site
            </Link>
            <h1 className="font-display font-700 uppercase tracking-tighter text-3xl md:text-5xl mt-4">
              Demandes de <span className="text-cyan">devis</span>
            </h1>
          </div>
          <div className="flex items-center gap-3">
            {user && (
              <span className="hidden sm:inline font-mono-accent text-xs text-neutral-500">{user.email}</span>
            )}
            <button
              data-testid="admin-refresh"
              onClick={load}
              className="inline-flex items-center gap-2 border border-white/10 rounded-full px-4 py-2 text-sm hover:border-cyan-400 hover:text-cyan transition-colors"
            >
              <RefreshCw size={15} /> Rafraîchir
            </button>
            <button
              data-testid="admin-logout"
              onClick={logout}
              className="inline-flex items-center gap-2 border border-white/10 rounded-full px-4 py-2 text-sm hover:border-red-400 hover:text-red-400 transition-colors"
            >
              <LogOut size={15} /> Déconnexion
            </button>
          </div>
        </div>

        {loading ? (
          <p className="text-neutral-500 font-light">Chargement...</p>
        ) : quotes.length === 0 ? (
          <div className="flex flex-col items-center gap-4 py-24 text-neutral-500">
            <Inbox size={48} />
            <p className="font-light">Aucune demande pour le moment.</p>
          </div>
        ) : (
          <div className="grid grid-cols-1 md:grid-cols-2 gap-5">
            {quotes.map((q) => (
              <div
                key={q.id}
                data-testid={`admin-quote-${q.id}`}
                className="glass rounded-2xl border border-cyan-500/15 p-6"
              >
                <div className="flex items-center justify-between mb-3">
                  <span className="font-display font-600 text-lg">{q.name}</span>
                  <span className="font-mono-accent text-[10px] uppercase tracking-widest bg-cyan-400/15 text-cyan px-2.5 py-1 rounded-full">
                    {new Date(q.created_at).toLocaleDateString("fr-FR")}
                  </span>
                </div>
                <p className="text-cyan text-sm mb-3">{q.service}</p>
                <div className="text-neutral-300 text-sm font-light space-y-1">
                  <p><span className="text-neutral-500">Véhicule :</span> {q.vehicle}</p>
                  <p><span className="text-neutral-500">Email :</span> {q.email}</p>
                  <p><span className="text-neutral-500">Tél :</span> {q.phone}</p>
                  {q.message ? <p className="pt-2 border-t border-white/10 mt-2">{q.message}</p> : null}
                </div>
              </div>
            ))}
          </div>
        )}
      </div>
    </div>
  );
}
